import { Notice } from '@MP/shared/api/types';

import { NoticeDialog } from './NoticeDialog';

interface NoticeProviderProps {
  notices: Notice[];
  onClose: (notice: Notice, optionChecked: boolean) => void;
}

const NoticeProvider = ({ notices, onClose }: NoticeProviderProps) => {
  return (
    <>
      {notices.map((v) => (
        <NoticeDialog key={v.timestampId} notice={v} onClose={(optionChecked) => onClose(v, optionChecked)} />
      ))}
    </>
  );
};

export { NoticeProvider };
